import { j as r } from "../../jsx-runtime-p91LotPX.mjs";
import { S as t, M as n } from "../../style-BCs5tvAM.mjs";
const {
  confirm: s
} = n;
function i(o) {
  return /* @__PURE__ */ r.jsx(t, { ...o });
}
const f = s;
export {
  f as AntConfirm,
  f as ConFirm,
  i as GrowModal
};
//# sourceMappingURL=AntModal.js.map
